import { Button } from "@/components/ui/button";
import { MessageCircle, ShieldAlert } from "lucide-react";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer className="bg-card/30 backdrop-blur-xl border-t border-border py-12">
      <div className="container px-4">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-3 gap-8 mb-8">
            {/* Brand */}
            <div className="space-y-4">
              <div className="flex items-center gap-2">
                <div className="text-2xl font-bold gradient-x-animated">
                  Oraculus:X
                </div>
              </div>
              <p className="text-sm text-muted-foreground leading-relaxed">
                Elite crypto trading signals unified in one powerful platform.
              </p>
            </div>

            {/* Quick Links */}
            <div className="space-y-4">
              <h3 className="font-semibold text-lg">Quick Links</h3>
              <ul className="space-y-2 text-sm">
                <li><a href="/features" className="text-muted-foreground hover:text-primary transition-colors">Features</a></li>
                <li><a href="/pricing" className="text-muted-foreground hover:text-primary transition-colors">Pricing</a></li>
                <li><a href="/roadmap" className="text-muted-foreground hover:text-primary transition-colors">Upcoming</a></li>
                <li><a href="https://dashboard.oraculusx.com" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary transition-colors">Dashboard</a></li>
                <li><a href="/faq" className="text-muted-foreground hover:text-primary transition-colors">FAQ</a></li>
              </ul>
            </div>

            {/* Connect */}
            <div className="space-y-4">
              <h3 className="font-semibold text-lg">Connect</h3>
              <div className="flex gap-3">
                <Button 
                  variant="outline" 
                  size="icon"
                  className="border-primary/50 hover:bg-primary/10"
                  asChild
                >
                  <a 
                    href="https://discord.gg/fxXR3h8b9k"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Join Discord Community"
                  >
                    <MessageCircle className="w-5 h-5" />
                  </a>
                </Button>
              </div>
              <p className="text-sm text-muted-foreground">
                Join our growing community and stay updated with the latest signals and insights.
              </p>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="pt-8 border-t border-border/50">
            <div className="flex flex-col md:flex-row justify-between items-center gap-4">
              <p className="text-sm text-muted-foreground">
                © {new Date().getFullYear()} Oraculus:X. All rights reserved.
              </p>
              <p className="text-xs text-muted-foreground max-w-md text-center md:text-right leading-relaxed">
                {t('footer.legalText')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;